import React from 'react';
import {
  VirtualTableColumnDef as ColumnDef,
} from 'core/components/VirtualTable/types';
import {
  BillingProviderPtanDTO,
} from 'dtos';
import {
  DeleteConfigCell,
} from 'views/EMR/Settings/BillingConfigurations/columns';
import {
  BillingProviderSummary,
  PayerSummary,
} from 'views/EMR/Settings/BillingConfigurations/BillingProviderRules/columns';

const billingProviderPtanColumns: ColumnDef<BillingProviderPtanDTO>[] = [{
  id: 'billingProviderId',
  accessorKey: 'billingProviderId',
  columnTitle: 'Billing Provider',
  meta: { autoSized: true },
  minSize: 150,
  cell: ({ row: { original: { billingProviderSummary } } }) => (
    <BillingProviderSummary billingProviderSummary={billingProviderSummary} />
  ),
}, {
  id: 'payerEntryId',
  accessorKey: 'payerEntryId',
  columnTitle: 'Payer',
  meta: { autoSized: true },
  minSize: 150,
  cell: ({ row: { original: { payerEntrySummary } } }) => (
    <PayerSummary payerEntrySummary={payerEntrySummary} />
  ),
}, {
  id: 'ptan',
  accessorKey: 'ptan',
  columnTitle: 'PTAN',
  size: 160,
  minSize: 100,
  cell: ({ row: { original: { ptan } } }) => (
    <div className="truncate w-full">
      {ptan}
    </div>
  ),
}, {
  id: 'actions',
  accessorKey: 'actions',
  columnTitle: '',
  size: 48,
  cell: ({ row: { original: { billingProviderPtanId } } }) => (
    <DeleteConfigCell
      type="billingProviderPtan"
      configTitle="PTAN"
      payload={{ billingProviderPtanId }}
      canDelete
    />
  ),
}];

export default billingProviderPtanColumns;
